/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ companyName: NonNullable<unknown> }} Dashboard_WelcomeInputs */

const en_dashboard_welcome = /** @type {(inputs: Dashboard_WelcomeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Welcome to the ${i?.companyName} Dashboard`)
};

const fr_dashboard_welcome = /** @type {(inputs: Dashboard_WelcomeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bienvenue sur le tableau de bord de ${i?.companyName}`)
};

/**
* | output |
* | --- |
* | "Welcome to the {companyName} Dashboard" |
*
* @param {Dashboard_WelcomeInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const dashboard_welcome = /** @type {((inputs: Dashboard_WelcomeInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_WelcomeInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_welcome(inputs)
	return fr_dashboard_welcome(inputs)
});